import { __assign } from "tslib";
import { cloneDeep, get, isNil } from 'lodash-es';
import * as screenLocation from '../constants/screenLocation';
import getAnimation, { getTransitionForTransitionToSameScreen, } from '../overlayTransitions';
import { doesHotspotExist, getBodyHotspots } from './hotspot';
import { getOverlayStyle } from './layout';
import { getStatusBarTrimHeight } from './statusBar';
export function getOverlayByID(state, id) {
    return get(state, ['project', 'config', 'overlayMap', id]);
}
export function getOverlay(state, isCurrentScreen) {
    var _a = state.screen, previousOverlayHotspot = _a.previousOverlayHotspot, currentOverlayHotspot = _a.currentOverlayHotspot;
    var hotspotID;
    var hotspot;
    var overlay;
    var animationDirection;
    var transition = '';
    var screenScrollPos;
    var overridePosition;
    if (isCurrentScreen) {
        if (currentOverlayHotspot.id) {
            hotspotID = currentOverlayHotspot.id;
            (screenScrollPos = currentOverlayHotspot.screenScrollPos, overridePosition = currentOverlayHotspot.overridePosition);
            if (currentOverlayHotspot.animate) {
                animationDirection = 'enter';
                if (currentOverlayHotspot.transition) {
                    transition = getTransitionForTransitionToSameScreen(currentOverlayHotspot.transition);
                }
            }
        }
        else if (isAnimatingAwayPreviousOverlay(previousOverlayHotspot)) {
            hotspotID = previousOverlayHotspot.id;
            (screenScrollPos = previousOverlayHotspot.screenScrollPos, overridePosition = previousOverlayHotspot.overridePosition);
            animationDirection = 'leave';
            if (previousOverlayHotspot.transition) {
                transition = getTransitionForTransitionToSameScreen(previousOverlayHotspot.transition);
            }
        }
    }
    else if (isTransitioningToScreenFromOverlay(previousOverlayHotspot)) {
        hotspotID = previousOverlayHotspot.id;
        // We don't set animationDirection as the previous overlay
        // animates away with the screen it was showing on
    }
    if (hotspotID && doesHotspotExist(state, hotspotID)) {
        hotspot = state.project.config.hotspotMap[hotspotID];
        overlay = getOverlayByID(state, hotspot.destinationScreenID);
        if (!hotspot.isScrollable) {
            overlay = getOverlayWithMergedHotspots(overlay);
        }
        transition = transition || hotspot.transition;
    }
    return {
        hotspot: hotspot,
        overlay: overlay,
        animationDirection: animationDirection,
        transition: transition,
        screenScrollPos: screenScrollPos,
        positionParent: isCurrentScreen
            ? currentOverlayHotspot.positionParent
            : previousOverlayHotspot.positionParent,
        overridePosition: overridePosition,
    };
}
export function getOverlayProps(state, isCurrentScreen) {
    var _a = getOverlay(state, isCurrentScreen), hotspot = _a.hotspot, overlay = _a.overlay, animationDirection = _a.animationDirection, transition = _a.transition, screenScrollPos = _a.screenScrollPos, positionParent = _a.positionParent, overridePosition = _a.overridePosition;
    if (noOverlay(hotspot) ||
        hidingOverlayWithNoAnimation(animationDirection, transition)) {
        return {};
    }
    var renderedScreenDimensions = state.screen.renderedDimensions;
    var overlayStyle = getOverlayStyle(state, renderedScreenDimensions, hotspot, overlay, isCurrentScreen, positionParent, overridePosition);
    var animationConf;
    if (animationDirection && transition) {
        animationConf = getAnimation(transition, renderedScreenDimensions)[animationDirection];
    }
    var animationName = "".concat(transition, "-").concat(animationDirection);
    var statusBarTrimHeight = getStatusBarTrimHeight(state);
    return __assign({ id: hotspot.id, screenID: overlay.id, transition: animationName, key: animationName, hotspots: getBodyHotspots(state, overlay), imgURL: overlay.img.url, animation: animationConf, position: hotspot.overlayPosition, overridePosition: overridePosition, isScrollable: hotspot.isScrollable, screenScrollPos: hotspot.location === screenLocation.BODY ? screenScrollPos : 0, renderedScreenDimensions: renderedScreenDimensions, statusBarTrimHeight: statusBarTrimHeight }, overlayStyle);
}
export function getOverlayBackgroundColour(state, isCurrentScreen) {
    var _a = getOverlay(state, isCurrentScreen), animationDirection = _a.animationDirection, hotspot = _a.hotspot;
    if (animationDirection !== 'leave' && hotspot) {
        return hotspot.overlayBackgroundColour;
    }
    return null;
}
export function getOverlayBackgroundAnimate(state, isCurrentScreen) {
    if (!isCurrentScreen) {
        return false;
    }
    if (isTransitioningToOverlayFromOverlay(state)) {
        return false;
    }
    var hotspot = getOverlay(state, isCurrentScreen).hotspot;
    if (hotspot) {
        return !!hotspot.transition;
    }
    return false;
}
function isAnimatingAwayPreviousOverlay(previousOverlayHotspot) {
    return previousOverlayHotspot.animate;
}
function isTransitioningToScreenFromOverlay(previousOverlayHotspot) {
    return previousOverlayHotspot.id && !previousOverlayHotspot.animate;
}
function isTransitioningToOverlayFromOverlay(state) {
    var currentOverlayId = get(state, 'screen.currentOverlayHotspot.id');
    var previousOverlayId = get(state, 'screen.previousOverlayHotspot.id');
    return !isNil(currentOverlayId) && !isNil(previousOverlayId);
}
function noOverlay(hotspot) {
    return !hotspot;
}
function hidingOverlayWithNoAnimation(animationDirection, transition) {
    return animationDirection === 'leave' && !transition;
}
// when rendering an overlay we need to ignore the partitioning of hotspots into
// header/footer/body as overlays have no fixed areas.
function getOverlayWithMergedHotspots(overlay) {
    var overlayClone = cloneDeep(overlay);
    ['footer', 'header'].forEach(function (location) {
        overlayClone.hotspots = overlayClone.hotspots.concat(get(overlay, [location, 'hotspots'], []));
    });
    return overlayClone;
}
export function isShowingOverlay(state) {
    return state.screen.currentOverlayHotspot.id;
}
